import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class PucaFormService {

	constructor(public http: HttpClient) { }
	public getPucaFormDetails(): Observable<any> {
		return this.http.get(environment.BASE_URL_PUCA + 'das/getInitFormData')
	}

	public saveApplicationData(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PUCA + 'das/saveApplicationData', payload)
	}

	public getUniversityListUS(): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'education/getUniversityListByCountryId/222')
	}

	public getApplicationFormData(applicationId, profileId): Observable<any> {
		return this.http.get(`${environment.BASE_URL_HRD_PUCA}puca/getApplicationFormData/${applicationId | 0}/${profileId}`)
	}

	public isMaxApplicationExist(profileId): Observable<any> {
		return this.http.get(`${environment.BASE_URL_HRD_PUCA}puca/isMaxApplicationExist/${profileId}`)
	}

	public getSemesterlist(year): Observable<any> {
		return this.http.get(`${environment.BASE_URL_HRD_PUCA}puca/getSemesterList/${year}`)
	}

	public nextStep: Subject<boolean> = new Subject();

	public previousStep: Subject<boolean> = new Subject();

	public setNewPucaApplication: Subject<any> = new Subject();
}
